import React, { useState } from "react";
import "./UploadCSV.css";
import { authFetch } from "./authFetch";

export default function UploadCSV() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadResult, setUploadResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const handleFileSelect = (e) => {
    setSelectedFile(e.target.files[0]);
    setErrorMessage("");
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    document.getElementById("csv-input").value = "";
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setErrorMessage("Please select a CSV file.");
      return;
    }

    const confirmUpload = window.confirm(
      `Are you sure you want to upload "${selectedFile.name}"?`
    );
    if (!confirmUpload) return;

    const formData = new FormData();
    formData.append("file", selectedFile);

    setIsUploading(true);
    setErrorMessage("");

    try {
      const response = await authFetch(
        `${process.env.REACT_APP_API_BASE_URL}/upload-csv`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        const text = await response.text();
        setErrorMessage(text || "Upload failed.");
        setIsUploading(false);
        return;
      }

      const data = await response.json();
      setUploadResult(data);

      // CLEAR SELECTED FILE AFTER SUCCESS
      setSelectedFile(null);
      document.getElementById("csv-input").value = "";

    } catch (error) {
      console.error("Upload error:", error);
      setErrorMessage("Upload failed. Try again.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="upload-wrapper">
      <h2 className="admin-page-title upload-title">Upload CSV File</h2>

      <div className="upload-container">
      {/* Upload Box */}
      <div className="upload-box">
        <input
          id="csv-input"
          type="file"
          accept=".csv"
          onChange={handleFileSelect}
          style={{ display: "none" }}
        />

        {selectedFile && (
          <button className="remove-file-btn-corner" onClick={handleRemoveFile}>
            ✕
          </button>
        )}

        {!selectedFile && (
          <button
            className="choose-file-btn"
            onClick={() => document.getElementById("csv-input").click()}
          >
            Choose File
          </button>
        )}

        {selectedFile && (
          <p className="file-name">
            <strong>Selected:</strong> {selectedFile.name}
          </p>
        )}
      </div>

      <button className="upload-btn" onClick={handleUpload}>
        {isUploading ? "Uploading..." : "Upload"}
      </button>

      {errorMessage && <div className="upload-error">{errorMessage}</div>}

      {/* MODAL POPUP */}
      {uploadResult && (
  <div className="session-modal">
    <div className="session-modal-content">

      <h2 style={{ marginTop: 0, marginBottom: "18px", fontSize: "22px", fontWeight: 700 }}>
        Upload Summary
      </h2>

      <p><strong>Batch ID:</strong> {uploadResult.batchId}</p>
      <p><strong>Inserted:</strong> {uploadResult.inserted}</p>
      <p><strong>Updated:</strong> {uploadResult.updated}</p>
      <p><strong>Skipped:</strong> {uploadResult.skipped}</p>

      <div className="modal-buttons">
        <button
          className="stay-btn"
          onClick={() => setUploadResult(null)}
        >
          Close
        </button>
      </div>

    </div>
  </div>
)}


    </div>
    </div>
  );
}
